export function enumToArray<T>(enumValue: { [s: string]: T }): Exclude<T, string>[] {
    return Object.values(enumValue)
        .filter((val) => typeof val !== 'string')
        .map((val) => val as Exclude<T, string>);
}
